// Constants for directory management functionality

export const COMMON_BOOK_LIST_NAMES = [
  'all-books.json',
  'books.json', 
  'book-list.json',
  'catalog.json'
] as const;

export const BACKEND_BASE_URL = 'http://localhost:3001';

export const STORAGE_KEYS = {
  BOOK_DIRECTORIES: 'stored-book-directories',
  BOOK_LIST: 'bookList',
  CURRENT_BOOK_PATH: 'currentBookPath',
  LAST_SELECTED_DIRECTORY: 'last-selected-directory' // Track last selected directory name for local mode
} as const;

export const API_ENDPOINTS = {
  SCAN_DIRECTORY: '/api/books/scan-directory',
  BOOK_LIST_BY_PATH: '/api/books/list-by-path'
} as const;
